/**
 * ns.wow Notes
 * Facade class for public accessible core functionality.
 */

import $ from "jquery";

class NSNotes {


  static version() {
    return NSContext.plugins.notes.version;
  }


  static init() {

    // Replace HTML with A-tags and Ajax calls (admin-ajax.php)

    let $notes = $(NSContext.plugins.notes.noteSelector);

    $notes.each( (index, element) => {
      NSNotes.createLink(element);
    });

    // Add popup box to show the linked notes

    $('body').append(`<div class="nhsnote-box">
			<div class="nhsnote-box__background js-nhsnote-box-close"></div>
			<div class="nhsnote-box__inner js-nhsnote-box-inner">
				<button class="nhsnote-box__close js-nhsnote-box-close"></button>
				<div class="nhsnote-box__content js-nhsnote-box-content"></div>
			</div>
		</div>`);


    $(document).keyup(function(event) {
      if (event.keyCode === 27) {
        let element = event.target;
        NSNotes.closePopup(element);
      }
    });


    $(document).on('click', `.${NSContext.plugins.notes.noteLinkClass}`, (event) => {
      let element = event.target;
      NSNotes.openPopup(element);
      return false;
    });


    $(document).on('click', '.js-nhsnote-box-close', (event) => {
      let element = event.target;
      NSNotes.closePopup(element);
    });

  }


  static createLink(element) {

    let $note = $(element);
    const innerHtml = $note.html();
    const noteNumber = NSNotes.getNoteId(innerHtml.trim());
    let modalClass = '';
    const language = document.documentElement.lang.substring(0,2);

    if (typeof $note.attr('data-modal-class') !== 'undefined') {
      modalClass = $note.attr('data-modal-class');
    }

    if (noteNumber === '&nbsp;') {
      $note.hide();
      return true;
    } else if (noteNumber === 'Note') {
      return true;
    }

    const category = NSContext.plugins.notes.matchedCategory;

    if (!category) {
      //return true;
    }

    // Notes if more than one Number/Note is in the trigger

    let values = '';
    let separator = '';

    if (innerHtml.indexOf('/') !== -1) {
      values = innerHtml.split('/');
      separator = '/';
    } else {
      values = innerHtml.split(',');
      separator = ',';
    }

    let resolvedNotes = [];

    for (let i = 0; i < values.length; i++) {
      const note = values[i].trim();
      const url = `${NSContext.site.ajaxUrl}?action=${NSContext.plugins.notes.ajaxAction}&term_id=${category}&note=${note.replace(/\u00e4/g, "ae").replace(/\u00fc/g, "ue").replace(/\u00f6/g, "oe")}&class=${modalClass}&lang=${language}`;
      resolvedNotes.push(`<a data-href="${url}" class="${NSContext.plugins.notes.noteLinkClass}">${note}</a>`);
    }

    resolvedNotes = resolvedNotes.join(separator);
    $note.html(resolvedNotes);
    $(document).trigger("noteLinksAdded");

  }


  static getNoteId(string) {

    let output = '';
    output = string.replace(".", "\\.");
    output = output.replace("(", "");
    output = output.replace(")", "");
    return output;

  }


  static openPopup(element) {

    const $box = $('.nhsnote-box');
    const $boxInner = $box.find('.js-nhsnote-box-inner');
    const $boxContent = $box.find('.js-nhsnote-box-content');

    $box.fadeIn();
    $.ajax({
      url: $(element).attr('data-href'),
    }).always((data) => {
      $box.addClass('nhsnote-box--loaded');
      $boxContent.html(data);
      $boxInner.fadeIn();
      $(document).trigger("noteLoaded");
      window.dispatchEvent(new Event('resize'));
      document.querySelector('body').classList.add('notes-open');
    });

  }


  static closePopup(element) {

    const $box = $('.nhsnote-box');
    const $boxInner = $box.find('.js-nhsnote-box-inner');
    const $boxContent = $box.find('.js-nhsnote-box-content');

    document.querySelector('body').classList.remove('notes-open');

    $boxInner.fadeOut(() => {
      $boxContent.html('');
      $box.removeClass('nhsnote-box--loaded');
    });
    $box.fadeOut();
    $(document).trigger("noteClosed");

  }


}

export default NSNotes;
